import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, PRIMARY_OUTLET } from "@angular/router";
import "rxjs/add/operator/filter";
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CommonConstant } from '../../shared/constants/common.constants';
import { CacheService } from "../../shared/services/cache.service";
import { StoreService } from '../../shared/services/store.service';

@Component({
  selector: "breadcrumb",
  template: `
    <ol class="breadcrumb">
      <li *ngFor="let breadcrumb of breadcrumbs">
      <a *ngIf="breadcrumb.disabled; else enabledTemplate">{{ ('breadcrumb.' + breadcrumb.label) | translate }}</a>
      <ng-template #enabledTemplate>
        <a *ngIf="!(breadcrumb.isTerminal)" [routerLink]="[breadcrumb.url, breadcrumb.params]">{{ ('breadcrumb.' + breadcrumb.label) | translate }}</a>
        <a *ngIf="(breadcrumb.isTerminal)" style="color: #ffa500;" [routerLink]="[breadcrumb.url, breadcrumb.params]">{{ ('breadcrumb.' + breadcrumb.label) | translate}}</a>
      </ng-template>
        </li>
      <div *ngIf="storeName"  class="ribbon-content">
        <div class="ribbon base-alt"> <span>{{ storeName }}</span></div>
      </div>
    </ol>
   
  `
})
export class AppBreadcrumbComponent implements OnInit {

  public breadcrumbs: any[];
  displayStore: boolean;
  storeName : any;

  @Input() menu: any;

  /**
   * @class DetailComponent
   * @constructor
   */
  constructor(
    private activatedRoute: ActivatedRoute,
    private _cacheService: CacheService,
    private storeService: StoreService
  ) {
    this.breadcrumbs = [];
    this.storeService.storeNameObservable.subscribe(storeName => {this.storeName = storeName;
      if(this.storeName != undefined && this.storeName.length > 0){
        this.displayStore = true;      
      }
      else{
        this.displayStore = false;
      }
    });
   
  }

  /**
   * Let's go!
   *
   * @class DetailComponent
   * @method ngOnInit
   */
  ngOnInit() {
     let menuGroupName= this._cacheService.get(CacheKey.SideMenuPosition);
     let allowedMenu:string[]=[CommonConstant.Catalog_Details,CommonConstant.Store_Details,CommonConstant.Shipping,CommonConstant.Stores]
      if(!(allowedMenu.indexOf(menuGroupName)>=0)){
        this.storeName=null
      }
    
    //subscribe to the NavigationEnd event
   // this.router.events.filter(event => event instanceof NavigationEnd).subscribe(event => {
      //set breadcrumbs
      let root: ActivatedRoute = this.activatedRoute.root; 
      this.breadcrumbs = this.getBreadcrumbs(root);
    //});  
    this.breadcrumbs[this.breadcrumbs.length-1].isTerminal =true;
  }
  /**
   * Returns array of IBreadcrumb objects that represent the breadcrumb
   *
   * @class DetailComponent
   * @method getBreadcrumbs
   * @param {ActivateRoute} route
   * @param {string} url
   * @param {IBreadcrumb[]} breadcrumbs
   */
  private getBreadcrumbs(route: ActivatedRoute, url: string="", breadcrumbs: any[]=[]): any[] {
    const ROUTE_DATA_BREADCRUMB: string = "breadcrumb";
    const DISABLED: string = "disabled";
    //get the child routes
    let children: ActivatedRoute[] = route.children;

    //return if there are no more children
    if (children.length === 0) {
      return breadcrumbs;
    }
    //iterate over each children
    for (let child of children) {
      //verify primary route
      if (child.outlet !== PRIMARY_OUTLET) {
        continue;
      }

      //verify the custom data property "breadcrumb" is specified on the route
      if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
        return this.getBreadcrumbs(child, url, breadcrumbs);
      }

      //get the route's URL segment
      let routeURL: string = child.snapshot.url.map(segment => segment.path).join("/");

      //append route URL to URL
      url += `/${routeURL}`;

      //add breadcrumb
      let breadcrumb: any = {
        label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
        disabled:child.snapshot.data[DISABLED] || false,
        params: child.snapshot.params,
        url: url,
        isTerminal : false
      };
      breadcrumbs.push(breadcrumb);
      //recursive
      return this.getBreadcrumbs(child, url, breadcrumbs);
    }
 }
  

}


// WEBPACK FOOTER //
// ./src/app/common/components/app-breadcrumb.component.ts